import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from "reactstrap";
import dynamic from "next/dynamic";
import {useQuery} from "@apollo/react-hooks";
import CAMPER_PICKUP_LOCATIONS from "../../../../graphql/queries/camperPickupLocations";
import moment from "moment";
import GET_USER from "../../../../graphql/queries/user_and_pickuplocations";
import {getSessionId} from "../../../../services/session";

const CamperSearchModal = dynamic(
    () => import('./CamperSearchModal'),
    {ssr: false}
);

const CamperSearch = () => {
    const sessionId = getSessionId();
    const [pickupLocation, setPickupLocation] = useState(null);
    const [dropOffLocation, setDropOffLocation] = useState(null);
    const [pickupDate, setPickupDate] = useState<moment.Moment>(null);
    const [dropOffDate, setDropOffDate] = useState<moment.Moment>(null);
    const [pickupLocations, setPickupLocations] = React.useState([]);
    const [lastSelectedCamperFilter, setLastSelectedCamperFilter] = React.useState(null);
    const [modal, setModal] = useState(false);
    const toggleModal = (): void => setModal(!modal);

    const {loading, error, data, client} = useQuery(GET_USER, {
        variables: {
            uuid: sessionId,
        },
    });

    useEffect(() => {
        if (data && data.CamperPickupLocations && data.CamperPickupLocations.locations) {
            setPickupLocations(data.CamperPickupLocations.locations.map(location => {
                return {
                    label: location.location,
                    value: location.id,
                    seoId: location.seoId,
                }
            }));
        }

        if (pickupLocations && data && data.user && data.user.lastSelectedCamperFilter) {
            setLastSelectedCamperFilter(data.user.lastSelectedCamperFilter)
        }
    }, [data])

    useEffect(() => {
        if (pickupLocations.length > 0 && lastSelectedCamperFilter) {
            setPickupDate(moment(lastSelectedCamperFilter.pickupDate));
            setDropOffDate(moment(lastSelectedCamperFilter.dropOffDate));
            setPickupLocation(pickupLocations.find(location => location.label === lastSelectedCamperFilter.pickupLocation));
            setDropOffLocation(pickupLocations.find(location => location.label === lastSelectedCamperFilter.dropOffLocation));
        }
    }, [pickupLocations, lastSelectedCamperFilter])

    return (
        <Row>
            <Col sm="12">
                <Button block color="light" onClick={toggleModal}>
                    <i className="fa fa-search text-primary mobile-search-icon"/>
                    <span className="mobile-search-button">Camper zoeken</span>
                </Button>
            </Col>
            {modal &&
                // @ts-ignore
                <CamperSearchModal
                    locations={pickupLocations}
                    initialDropOffLocation={pickupLocation}
                    initialPickupLocation={dropOffLocation}
                    initialDropOffDate={dropOffDate}
                    initialPickupDate={pickupDate}
                    isOpen={modal}
                    toggle={() => toggleModal()}
                />
            }
        </Row>
    )
}

export default CamperSearch;
